import apiClient from "./apiClient";

const toUserList = (payload) => {
  const directList =
    payload?.users ??
    payload?.stationUsers ??
    payload?.station_users ??
    payload?.data?.users ??
    payload?.data?.stationUsers ??
    payload?.data?.station_users ??
    payload?.data;

  if (Array.isArray(directList)) {
    return directList;
  }

  const singleUser = payload?.user ?? payload?.data?.user;

  if (singleUser && typeof singleUser === "object") {
    return [singleUser];
  }

  if (directList && typeof directList === "object") {
    return [directList];
  }

  const nestedArray = Object.values(payload || {}).find((value) =>
    Array.isArray(value)
  );

  if (Array.isArray(nestedArray)) {
    return nestedArray;
  }

  return [];
};

export const getStationUsers = async (params = {}) => {
  const response = await apiClient.get("/api/station/users", { params });
  return toUserList(response.data);
};

export const getStationUserById = async (userId) => {
  const response = await apiClient.get(`/api/station/users/${userId}`);
  return response.data?.user || response.data?.data || response.data || null;
};

export const createStationUser = async (payload) => {
  const response = await apiClient.post("/api/station/users", payload);
  return response.data;
};

export const updateStationUser = async (userId, payload) => {
  const response = await apiClient.put(`/api/station/users/${userId}`, payload);
  return response.data;
};
